import { Injectable } from '@angular/core';
import { Config } from './config/config'
import { HttpClient } from '@angular/common/http'
import { StorageService } from './config/storage.service'

@Injectable({
  providedIn: 'root'
})
export class HomeService extends Config{

  constructor(
      private http:HttpClient,
      private storage:StorageService,
  ) { 
     super()
  }

    getTopList(){
        let url = 'public/get_top_list';
        return this.http.get(this.BASE_URL_API + url,this.storage.getHeaders())
    }
    getFundraiserList(){
      let url = 'public/get_fundraiser_list';
        return this.http.get(this.BASE_URL_API + url,this.storage.getHeaders())
    }
    // saveContactUs(c){
    //   let url = 'public/save_contact_us'

    //   //let url = 'public/get_items'
    //   return this.http.post(this.BASE_URL_API + url,c,this.storage.getHeaders())
    // }

    // tracking(c){
    //   let url = 'public/tracker'

    //   //let url = 'public/get_items'
    //   return this.http.post(this.BASE_URL_API + url,c,this.storage.getHeaders())
      
    // }

}
